import { render, staticRenderFns } from "./MbGameControllPanel.vue?vue&type=template&id=560b1ac8&scoped=true&"
import script from "./MbGameControllPanel.vue?vue&type=script&lang=js&"
export * from "./MbGameControllPanel.vue?vue&type=script&lang=js&"
import style0 from "./MbGameControllPanel.vue?vue&type=style&index=0&id=560b1ac8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b1ac8",
  null
  
)

export default component.exports